// extracted by mini-css-extract-plugin
export default {"root":"Header_root__y-isv"};